import PropTypes from 'prop-types';
import SportCouponViewImpl from './sport-coupon-view.js';
import MojitoCore from 'mojito/core';
const UIView = MojitoCore.Presentation.UIView;

/**
 * View displaying a sport specific coupon.
 *
 * @class SportCouponView
 * @private
 * @memberof Mojito.Modules.SportCoupon
 */

/**
 * `SportCouponView` prop types.
 *
 * @property {string} sportId - The sport id.
 * @property {string} couponId - The coupon id.
 * @property {string} [todayEventGroupId] - Event group id for today's events.
 * @property {string} [tomorrowEventGroupId] - Event group id for tomorrow's events.
 *
 * @memberof Mojito.Modules.SportCoupon.SportCouponView
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    couponId: PropTypes.string.isRequired,
    todayEventGroupId: PropTypes.string,
    tomorrowEventGroupId: PropTypes.string,
};

export default UIView('SportCouponView', SportCouponViewImpl, propTypes);
